import { Component, signal, ViewEncapsulation, WritableSignal, OnInit,Input,effect, input, inject   } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import {TableRow, TableColumn} from '../../../../shared/models/components/tables/table.models';
import { DialogModule  } from 'primeng/dialog';
import { TooltipModule  } from 'primeng/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ModalCreateScenarioComponent } from './modal-create-scenario/modal-create-scenario.component';
import { InputsTableComponent } from './inputs-table/inputs-table.component';
import { ResultsTableComponent } from './results-table/results-table.component';
import { ModelPredictionsInputs,ModelInputResponse } from '../../../../shared/models/serviceModels/request/modelPredictionsInputs.model';
import { ModelPredictionsResults,ModelResultModel,ModelResultResponse } from '../../../../shared/models/serviceModels/response/modelPredictionsResults.model';
import {ModelPredictionsService} from '../../../../shared/services/componentsServices/modelPredictions.service';
import { ModelChartsComponent } from './model-charts/model-charts.component';
import { SharedDataService } from '../../../../shared/services/componentsServices/shared-data.service';
import { Sat, Region, Commodity, ProjectFilterModel,InputsAndValuesModel } from '../../../../../app/shared/models/store/filter.model'; // Importa las interfaces
import { filter,take } from 'rxjs/operators';
import { combineLatest, forkJoin } from 'rxjs';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { NotificationPopupComponent } from '../../../../shared/components/notification-popup/notification-popup.component';
import { SavePredictionsModel } from '../../../../shared/models/serviceModels/request/savePredictionsReq.model';
import { ChevronConfirmPopupComponent } from './chevron-confirm-popup/chevron-confirm-popup.component';

import { LoadingButtonComponent } from '../../../../shared/components/loading-button/loading-button.component';
import { PermissionService } from '../../../../shared/services/security/permission.service';
import { UserProfileStore } from '../../../../shared/store/user-profile.store';
import { Feature } from '../../../../shared/security/feature-permissions';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import {SavePredictionsResponse}  from '../../../../shared/models/serviceModels/response/savePredictionsResponse.model';

@Component({
    selector: 'app-model-predictions',
    imports: [
        LoadingButtonComponent,
        NotificationPopupComponent,
        CommonModule,
        TableModule,
        FormsModule,
        DialogModule,
        TooltipModule,
        FontAwesomeModule,
        SelectModule,
        DatePickerModule,
        ModalCreateScenarioComponent,
        InputsTableComponent,
        ResultsTableComponent,
        ModelChartsComponent,
        ChevronConfirmPopupComponent
    ],
    templateUrl: './model-predictions.component.html',
    styleUrl: './model-predictions.component.scss',
    providers: []
})

export class ModelPredictionsComponent implements OnInit {
  isChartsModalOpen = signal(false);
  isModalOpen = signal(false);
  isNotificationPopupOpen = signal(false);
  // isNotificationPopupVisible = signal(false);
  newColumnName: string = '';
  baseScenario: WritableSignal<TableColumn | null> = signal(null) ;
  columnCounter = 0; // To generate unique field names for dynamic columns
  date: Date | undefined;
  backupDate: Date= new Date();
  faSpinner=faSpinner;

  isResultVisible = signal(false);
  areInputsloading = signal(false);

  emptyModuleMessage = signal('Select a project from the filters to see the inputs and values');
  isInputsModuleVisible = signal(true);
  inputsVisible = signal(true);
  isLoadingData = signal(false);
  InputsAndValuesModel: InputsAndValuesModel[] = [];
  navBarFilters: ProjectFilterModel = {commodityId: 0, regionId: 0, satId: 0, projectId: 0};
  currentProject: number =0;
  faPlus = faPlus;
  selectedDate: string= "";
  data: any[] = [];
  inputColumns: WritableSignal<TableColumn[]>  = signal([]);

  inputRows: WritableSignal<TableRow[]>  = signal([]);
  backupInputRows: WritableSignal<TableRow[]>  = signal([]);

  scenariosFields: WritableSignal<string[]>  = signal([]);
  rowsCategories: WritableSignal<string[]>  = signal([]);
  columnsResults: WritableSignal<TableColumn[]>  = signal([]);
  rowsResults: WritableSignal<TableRow[]> = signal([]);
  isSpinnerVissible = signal(false);
  isResetSpinnerVissible = signal(false);
  isDateSpinnerVissible = signal(false);
  errorMessage: WritableSignal<string> = signal("") ;
  secondErrorMessage: WritableSignal<string> = signal("") ;
  faCircle = faCircle;
  canEditChevronCase = false;

  chevronDirty = signal(false);
  savingChevron = signal(false);
  // Indicates if (at load or after last save) Chevron case values were identical to Bentek case
  chevronBaselineEqualsBentek = signal(false);
  // Confirm dialog state & message for saving Chevron case
  isChevronConfirmOpen = signal(false);
  chevronConfirmMessage = signal('');
  chevronConfirmDetails = signal<{lastModifiedBy?: string; lastModifiedAt?: string; diffs: {inputId: number; name: string; oldValue: string|number; newValue: string|number;}[]}>({diffs:[]});
  loadingBaseline = signal(false);
  preparingChevronConfirm = signal(false);
  chevronAuditTrail = signal<{changes: {correlationId:string; user:string; occurredAtUtc:string; inputId:number; uiName:string; oldValue:any; newValue:any;}[]}>({changes: []});

  private userProfileStore = inject(UserProfileStore);
  savingPredictions = signal(false);

  constructor(
    library: FaIconLibrary,
    private modelPredictionsService: ModelPredictionsService,
    private SharedDataService:SharedDataService,
    private permissionService: PermissionService){
    const columnsValue = this.inputColumns();
    if (columnsValue.length > 1) {
      this.baseScenario.set(columnsValue[1]);
    }
    library.addIconPacks(fas);

    effect(() => {
      this.navBarFilters = this.SharedDataService.getNavBarFilters();
      let currentProject = this.modelPredictionsService.getCurrentProject();

      if(currentProject === 0 || currentProject != this.navBarFilters.projectId){
        this.modelPredictionsService.setCurrentProject(this.navBarFilters.projectId);
        this.currentProject = this.navBarFilters.projectId;
        this.getDataFromService();
      }

    });

  }

  setCurrentScope(currentDate: Date) {

    const currentMonth = currentDate.getMonth() + 1; // Months are zero-based

    // If the month is November (11), December (12), or January (1), set scope to 2
    if (currentMonth === 11 || currentMonth === 12 || currentMonth === 1) {
      this.modelPredictionsService.setCurrentScope(2);
      return
    }

    this.modelPredictionsService.setCurrentScope(1);
    return;
  }

  getDataFromService(selectedDate: string = "") {
    if(this.currentProject === 0){
      this.isInputsModuleVisible.set(false);
      return;
    }

    this.areInputsloading.set(true);

    const filterRequest: ProjectFilterModel = this.navBarFilters;

    filterRequest.selectedDate = selectedDate;
    this.isLoadingData.set(true);

 //need to show popUp here, block run button and show message. Reload table with default values.
    this.modelPredictionsService.GetInputsAndValuesFromService(filterRequest).subscribe(
      (data: ModelInputResponse) => {

        if((data.errorMsg && data.errorMsg.length > 0) || data.results.length === 0){
          this.handleError(data.errorMsg || 'No inputs and values found for the selected project and date.');
          this.isDateSpinnerVissible.set(false);
          return;
        }

        this.isLoadingData.set(false);
        this.backupDate= this.date ? this.date : new Date();

        this.SharedDataService.setIsNavbarEnabled(true);
        this.inputsVisible.set(true);
        this.areInputsloading.set(false);
        this.isInputsModuleVisible.set(true);
  this.mapInputsFromService(data);
  this.isDateSpinnerVissible.set(false);
      }
    );
  }

  handleError(errorMsg: string){

    //if rows have data, load: available rows and columns, and set last date selected

    this.handleErrorMessage(errorMsg, "Please check the inputs and try again.");

    this.setDateInBackupAndUi(this.backupDate);
    this.isLoadingData.set(false);
  this.isDateSpinnerVissible.set(false);

    if(this.inputColumns().length > 0){
      return;
    }

     //if rows have no data, hide inputs table, show error message and disable run button

    this.inputsVisible.set(false);
    this.inputColumns.update(() => []);
    this.inputRows.update(() => []);
    this.columnsResults.set([]);
    this.rowsResults.set([]);
    this.isLoadingData.set(false);
  this.isDateSpinnerVissible.set(false);

    return;
  }

  ngOnInit() {
    const initialColumns = this.inputColumns();
    if (initialColumns.length > 1) {
      this.baseScenario.set(initialColumns[1]);
    }

  this.currentProject = this.modelPredictionsService.getCurrentProject();
    if(this.currentProject === 0){
      this.isInputsModuleVisible.set(false);
      this.emptyModuleMessage.set('Select a project from the filters to see the inputs and values');
      return;
    }

  this.evaluateChevronCaseEditPermission();
  this.setDataInUi();
  }


  setDataInUi() {

    let currentInputs= this.modelPredictionsService.getInputColumns();
    let currentResults= this.modelPredictionsService.getResultsColumns();
    let currentDate = this.modelPredictionsService.getCurrentSelectedDate();
    let currentCategories = this.modelPredictionsService.getCurrentCategories();

    if(currentInputs().length>0){
      this.inputColumns.update(()=> currentInputs());
      this.evaluateChevronCaseEditPermission();

      let currentRows= this.modelPredictionsService.getInputRows();
      this.inputRows.update(()=>currentRows());

      if(currentDate.length>0){
        this.selectedDate= currentDate;
        this.date = new Date(currentDate);
      }

      if(currentResults().length>0){
        let currentResultsRows= this.modelPredictionsService.getResultsRows();
        this.setResultsInTable(currentResults(), currentResultsRows(), true);
      }

      if(currentCategories().length>0){
        this.rowsCategories.update(()=>currentCategories());
      }
  this.recomputeChevronDirty();

      return;
    }

    this.getDataFromService();

  }

  setDate(currentDate: string =""){
    this.selectedDate= currentDate;
    this.date = currentDate ? new Date(currentDate) : undefined;
    this.modelPredictionsService.setCurrentSelectedDate(currentDate);
  }

  mapInputsFromService(data: ModelInputResponse) {

    let inputColumns: TableColumn[] = this.setTableColumns(data);

    let inputRows: TableRow[]=[];
    const runDate =  data.results[0]?.values[0].runDate || "";
    const formattedDate = runDate ? this.formatDate(runDate) : '';

    this.setDate(formattedDate);

    this.setCurrentScope(data.results[0]?.values[0].runDate ? new Date(data.results[0]?.values[0].runDate) : new Date());

    let scenariosFields: string[] = data.results.map(item => item.scenarioField);
    this.scenariosFields.update(()=>scenariosFields);

    // this.backupInputRows.update(()=>this.setTableRows(data).sort((a, b) => (a.dataCategory || '').localeCompare(b.dataCategory || '')));

    let currentInputRows: TableRow[] = this.setTableRows(data).map(row => {
      const metaKeys = new Set(['name','inputId','maxVal','minVal','percentile10','percentile90','field','description','dataCategory']);
      Object.keys(row).forEach(key => {
        if (key === "name" && typeof row[key] === "string") {
          row[key] = row[key]
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
            .replace(/_/g, ' ')
            .trim();
        } else if (!metaKeys.has(key) && !isNaN(Number(row[key])) && typeof row[key] !== 'object') {
          const rawKey = `${key}`;
          const backupKey = `${key}_backup`;
          const displayKey = `${key}_display`;
          const rawVal = String(row[rawKey]);
          row[backupKey] = rawVal;
          row[displayKey] = Number(rawVal).toFixed(2);
          row[rawKey] = rawVal;
        }
      });
      return row;
    });

    inputRows = currentInputRows.sort((a, b) => (a.dataCategory || '').localeCompare(b.dataCategory || ''));

  this.inputColumns.update(()=> inputColumns);
    this.inputRows.update(()=>inputRows);

  this.evaluateChevronCaseEditPermission();
  this.updateCurrentInputsValues();
    this.updateBackupValues();
    this.getRowsCategories(inputRows);
    this.modelPredictionsService.setCurrentCategories(this.rowsCategories());
  this.computeChevronBentekBaselineEquality();

  }


  setTableColumns(data: ModelInputResponse):TableColumn[]{
      let columns: TableColumn[]= [];

      columns.push({ header: 'Inputs', field: 'field',name:'name',  editable: false, deletable: false,  isFrozen: true },);
      data.results.forEach(item=>{
        columns.push({ header: item.scenarioName, field: item.scenarioField,name:item.scenarioName,  editable: false, deletable: false,  isFrozen: false, caseId: item.caseId },);
      })

      return columns;
  }

  private evaluateChevronCaseEditPermission() {
    const hasPerm = this.permissionService.can('modelPredictions:editChevronCases');
    this.canEditChevronCase = hasPerm;
    this.inputColumns.update(cols => cols.map(c => {
      if (typeof c.caseId === 'number' && c.caseId === 2) {
        return { ...c, editable: hasPerm };
      }
      return c;
    }));
  }

  private getChevronCaseColumn(): TableColumn | undefined {
    return this.inputColumns().find(c => c.caseId === 2);
  }

  private getBentekCaseColumn(): TableColumn | undefined {
    return this.inputColumns().find(c => c.caseId === 1);
  }

  private computeChevronBentekBaselineEquality() {
    const chevronCol = this.getChevronCaseColumn();
    const bentekCol = this.getBentekCaseColumn();
    if(!chevronCol || !bentekCol){
      this.chevronBaselineEqualsBentek.set(false);
      return;
    }
    const chevronField = chevronCol.field;
    const bentekField = bentekCol.field;
  const equal = !this.inputRows().some(r => !this.areValuesEqualTwoDecimals(r[chevronField + '_backup'], r[bentekField + '_backup']));
    this.chevronBaselineEqualsBentek.set(equal);
  }

  private recomputeChevronDirty() {
    const chevronCol = this.getChevronCaseColumn();
    if (!chevronCol) {
      this.chevronDirty.set(false);
      return;
    }
    const field = chevronCol.field;
  const dirty = this.inputRows().some(r => !this.areValuesEqualTwoDecimals(r[field], r[`${field}_backup`]));
    this.chevronDirty.set(dirty);
  }

  onValueChanged(event: {row: TableRow; field: string}) {
    const row = event.row;
    const rawStr = String(row[event.field] ?? '');
    const normalized = rawStr.replace(/,/g, '');
    row[event.field] = normalized;
    row[`${event.field}_display`] = !isNaN(Number(normalized)) ? Number(normalized).toFixed(2) : normalized;

    const chevronCol = this.getChevronCaseColumn();
    if (chevronCol && event.field === chevronCol.field) {
      this.recomputeChevronDirty();
    }
  }

  // Called by save icon click: opens confirm dialog with appropriate message
  saveChevronChanges() {
    if (!this.chevronDirty() || this.savingChevron()) return;
  this.preparingChevronConfirm.set(true);
  this.buildChevronConfirmation();
  }

  private buildChevronConfirmation() {
    const isFirst = this.chevronBaselineEqualsBentek();
    const userEmail = (this.userProfileStore.userProfile()?.email || '').toLowerCase();
    const chevronCol = this.getChevronCaseColumn();
    if(!chevronCol){ return; }
    const field = chevronCol.field;
    const localChanges = this.inputRows()
      .filter(r => !this.areValuesEqualTwoDecimals(r[field], r[`${field}_backup`]))
      .map(r => ({ inputId: Number(r.inputId), name: r.name as string, newValue: r[field], backupValue: r[`${field}_backup`] }));

    if(isFirst){
      const firstDiffs = localChanges.map(c => ({
        inputId: c.inputId,
        name: c.name,
        oldValue: c.backupValue,
        newValue: c.newValue
      })).filter(d => !this.areValuesEqualTwoDecimals(d.oldValue, d.newValue));
      this.chevronConfirmDetails.set({ diffs: firstDiffs });
      this.chevronConfirmMessage.set('You are about to save these values as the first official Chevron case. Review and confirm.');
      this.isChevronConfirmOpen.set(true);
      this.preparingChevronConfirm.set(false);
      return;
    }

    if(this.selectedDate && this.currentProject){
      this.loadingBaseline.set(true);
      const runDateIso = this.toApiRunDateString();
      
      forkJoin({
        baseline: this.modelPredictionsService.getChevronBaseline(this.currentProject, runDateIso),
        auditTrail: this.modelPredictionsService.getChevronAuditTrail(this.currentProject, runDateIso)
      }).subscribe({
        next: ({baseline, auditTrail}) => {
          // Process baseline
          const lastAuthor = (baseline?.lastModifiedByEmail || '').toLowerCase();
          const showDiffs = lastAuthor && lastAuthor !== userEmail;
          let displayDiffs: {inputId:number; name:string; oldValue:any; newValue:any;}[] = [];
          const officialMap = new Map<number, any>((baseline?.inputs||[]).map((i:any)=>[Number(i.inputId), i.officialValue]));
          displayDiffs = localChanges.map(c => ({
            inputId: c.inputId,
            name: c.name,
            oldValue: officialMap.has(c.inputId) ? officialMap.get(c.inputId) : c.backupValue,
            newValue: c.newValue
          })).filter(d => !this.areValuesEqualTwoDecimals(d.oldValue, d.newValue));
          const overwritingSomeone = showDiffs && displayDiffs.length > 0;
          if(overwritingSomeone){
            this.chevronConfirmMessage.set(`You are about to overwrite official Chevron values saved by ${baseline.lastModifiedByEmail}. Review and confirm the pending changes below.`);
          } else if(displayDiffs.length > 0){
            this.chevronConfirmMessage.set('Review the pending changes to update the official Chevron case.');
          } else {
            this.chevronConfirmMessage.set('No effective changes detected.');
          }
          this.chevronConfirmDetails.set({
            lastModifiedBy: overwritingSomeone ? baseline?.lastModifiedByEmail : undefined,
            lastModifiedAt: overwritingSomeone ? baseline?.lastModifiedAtUtc : undefined,
            diffs: displayDiffs
          });
          
          // Process audit trail
          if(auditTrail?.changes){
            const sortedChanges = [...auditTrail.changes].sort((a, b) => {
              const dateA = new Date(a.occurredAtUtc).getTime();
              const dateB = new Date(b.occurredAtUtc).getTime();
              return dateB - dateA;
            });
            this.chevronAuditTrail.set({ changes: sortedChanges });
          }
          
          this.loadingBaseline.set(false);
          this.isChevronConfirmOpen.set(true);
          this.preparingChevronConfirm.set(false);
        },
        error: _ => {
          const fallbackDiffs = localChanges.map(c => ({
            inputId: c.inputId,
            name: c.name,
            oldValue: c.backupValue,
            newValue: c.newValue
          })).filter(d => !this.areValuesEqualTwoDecimals(d.oldValue, d.newValue));
          this.chevronConfirmMessage.set('Review the pending changes to update the official Chevron case.');
          this.chevronConfirmDetails.set({ diffs: fallbackDiffs });
          this.loadingBaseline.set(false);
          this.isChevronConfirmOpen.set(true);
          this.preparingChevronConfirm.set(false);
        }
      });
    } else {
      const noContextDiffs = localChanges.map(c => ({
        inputId: c.inputId,
        name: c.name,
        oldValue: c.backupValue,
        newValue: c.newValue
      })).filter(d => !this.areValuesEqualTwoDecimals(d.oldValue, d.newValue));
      this.chevronConfirmMessage.set('Review the pending changes to update the official Chevron case.');
      this.chevronConfirmDetails.set({ diffs: noContextDiffs });
      this.isChevronConfirmOpen.set(true);
    this.preparingChevronConfirm.set(false);
    }
  }

  confirmChevronSave() {
    if (!this.chevronDirty() || this.savingChevron()) { this.isChevronConfirmOpen.set(false); return; }
    const chevronCol = this.getChevronCaseColumn();
    if (!chevronCol) { this.isChevronConfirmOpen.set(false); return; }
    const field = chevronCol.field;
    const apiRunDate = this.toApiRunDateString();
    const changes = this.inputRows()
      .filter(r => !this.areValuesEqualTwoDecimals(r[field], r[`${field}_backup`]))
      .map(r => ({
        caseId: 2,
        inputId: Number(r.inputId),
        value: String(r[field]),
        runDate: apiRunDate
      }));
    if (changes.length === 0) {
      this.chevronDirty.set(false);
      this.isChevronConfirmOpen.set(false);
      return;
    }
    this.savingChevron.set(true);
  this.modelPredictionsService.updateCaseInputs(this.currentProject, changes).subscribe({
      next: _ => {
        this.inputRows.update(rows => rows.map(r => {
          if (!this.areValuesEqualTwoDecimals(r[field], r[`${field}_backup`])) {
            r[`${field}_backup`] = r[field];
            r[`${field}_display`] = !isNaN(Number(r[field])) ? Number(r[field]).toFixed(2) : String(r[field]);
          }
          return r;
        }));
        this.recomputeChevronDirty();
        this.savingChevron.set(false);
        // After first successful save, treat as existing official version
        this.chevronBaselineEqualsBentek.set(false);
        this.isChevronConfirmOpen.set(false);
      },
      error: _ => {
        this.savingChevron.set(false);
        this.isChevronConfirmOpen.set(false);
      }
    });
  }

  cancelChevronSave() {
    this.isChevronConfirmOpen.set(false);
  }

  private areValuesEqualTwoDecimals(a: any, b: any): boolean {
    if (a === null || a === undefined || b === null || b === undefined) {
      return a === b; // both null/undefined are equal
    }
    const n1 = Number(a);
    const n2 = Number(b);
    if (!isNaN(n1) && !isNaN(n2)) {
      return n1.toFixed(2) === n2.toFixed(2);
    }
    return String(a) === String(b);
  }

  private toApiRunDateString(): string {
    if (!this.selectedDate) return new Date().toISOString();
    const parsed = new Date(this.selectedDate);
    if (isNaN(parsed.getTime())) return new Date().toISOString();
    return parsed.toISOString();
  }

  updateCurrentInputsValues() {
    this.modelPredictionsService.setInputsColumns(this.inputColumns());
    this.modelPredictionsService.setInputsRows(this.inputRows());
  }

  updateBackupValues(){
    this.modelPredictionsService.setInputsColumnsBackup(this.inputColumns());
    this.modelPredictionsService.setInputsRowsBackup(this.inputRows());
  }

  updateResultsServiceValues() {
    this.modelPredictionsService.setResultsColumns(this.columnsResults());
    this.modelPredictionsService.setResultsRows(this.rowsResults());
  }



  mapTableModelPredictionsInputs(rows: TableRow[], columns: TableColumn[] ): ModelPredictionsInputs[]{
    const result: ModelPredictionsInputs[] = [];

    const scenarioColumns = columns.filter(col=> !col.isFrozen);

    scenarioColumns.forEach(col=>{
      const scenarioData: ModelPredictionsInputs = {
        scenarioField: col.field,
        scenarioName: col.header,
        caseId: typeof col.caseId === 'number' ? col.caseId : undefined,
        values:[]
      };

      rows.forEach(row=>{
        if(row[col.field] !== undefined){
          scenarioData.values.push({
            name: row.field,
            field: row.field,
            value: String((row[col.field] ?? row[col.field + "_backup"]) ?? '').replace(/,/g, ''),
            inputId: row.inputId,
          })
        }
      })

      scenarioData.values.push({
        name: "run_date",
        field: "run_date",
        value:this.selectedDate,
        inputId: "0"
      })

      // scenarioData.values.push({
      //   name: "Date",
      //   field: "Date",
      //   value:this.selectedDate,
      //   inputId: "0"
      // })

      result.push(scenarioData)
    })

    return result;
  }

  setTableRows(serviceData: ModelInputResponse): TableRow[] {
     const serviceTableData: TableRow[] = [];


     const fields = serviceData.results[0].values.map(v => ({
      field: v.field,
      name: v.name,
      maxVal: v.maxVal,
      minVal: v.minVal,
      percentile10: v.percentile10,
      percentile90: v.percentile90,
      description: v.description,
      dataCategory: v.dataCategory }));

     fields.forEach(({ field, name, maxVal, minVal,percentile10,percentile90 ,description, dataCategory }) => {
     const row: TableRow = { name, inputId: null, maxVal, minVal,percentile10,percentile90,field, description, dataCategory };

     serviceData.results.forEach(input => {
     const foundValue = input.values.find(v => v.field === field);
     row[input.scenarioField] = foundValue ? foundValue.value : null;
     row.inputId = foundValue ? foundValue.inputId : null;
     });

     serviceTableData.push(row);
     });

     return serviceTableData;
    }


  getNewFieldName(newColumnName: string): string{

    const sanitizedField = newColumnName
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());

    const newField = `${sanitizedField}_${this.columnCounter++}`;

    let result= sanitizedField !== null && sanitizedField.length>0 ? newField : "";
    return result;
  }


  addColumn(event: {newColumnName: string; baseScenario: TableColumn | null}) {

    //the table renders a matrix. Everytime the user creates a new column, this adds a new object into the columns arry. Each object has
    //an unique identifier. This element is going to be linked/used as a new element in the dynamic rows object. It is going to take its value
    //from the column selected by the user. Here, we take the field from the column and search for the row property that matches this field.

    const {newColumnName, baseScenario} = event;

    if(!newColumnName || !baseScenario){
      return;
    }

    let currentName= this.getNewFieldName(newColumnName);
    const newField= currentName;
    const newName= currentName;

    const newColumn: TableColumn ={
      header: newColumnName,
      field: newField,
      name: newName,
      editable: true,
      deletable: true,
      isFrozen: false
    }

    this.inputColumns.update((cols)=> [...cols, newColumn]);

    this.inputRows.update((currentRows)=>{
      currentRows.forEach((row)=>{
        const baseField = baseScenario.field;
        const baseRaw = row[baseField];
        row[newColumn.field] = baseRaw;
        row[`${newColumn.field}_backup`] = baseRaw;
        row[`${newColumn.field}_display`] = !isNaN(Number(baseRaw)) ? Number(baseRaw).toFixed(2) : baseRaw;
      })
      return currentRows;
    })

    this.updateCurrentInputsValues();

    this.columnCounter++;

  }

  deleteColumn(field: string) {
    this.inputColumns.update((cols)=>{
      return cols.filter((col)=>col.field!==field);
    })

    this.inputRows.update((rows)=>{
      rows.forEach((row)=>{
        delete row[field];
        delete row[`${field}_backup`];
        delete row[`${field}_display`];
      })
      return rows;
    })

    this.updateCurrentInputsValues();
  }

  openAddColumnPopUp(){
    this.newColumnName = '';
    this.baseScenario.set(this.inputColumns()[1]);
    this.isModalOpen.set(true);
  }

  closeModal(){
    this.isModalOpen.set(false);
  }

  closeNotificationPopup(){
    this.isNotificationPopupOpen.set(false);
  }

  closeChartsModal(){
    this.isChartsModalOpen.set(false);
  }

  isRunButtonDisabled(){

    if(this.isLoadingData()===true){
      return true;
    }

    if(this.inputsVisible() ===false){
      return true;
    }

    if(this.date === undefined){
      return true;
    }

    return false;
  }

  isResetButtonDisabled(){
    return false;
  }


  mapPredictionsResultsRows(results: ModelResultModel[]): TableRow[]{

    const rowsResults: TableRow[] = results[0].caseModels.map((model, index) => {
      const row: TableRow = { field: model.modelName, inputId: null };
      results.forEach(item => {
        row[item.caseField] =  `$${item.caseModels[index].modelPrice}`;
      });
      return row;
    });

    const ensembleRow: TableRow = { field: 'Ensemble', inputId: null };
    results.forEach(item => {
      ensembleRow[item.caseField] = `$${item.caseAveragePrice}`;
    });
    rowsResults.push(ensembleRow);
    return rowsResults;
  }

  mapPredictionsResultsColumns(results: ModelResultModel[]): TableColumn[]{

    const columnsResults: TableColumn[] = [
      { header: this.selectedDate, field: 'field', name:'name',editable: false, deletable: false, isFrozen: true },
      ...results.map(item => ({
        header: item.caseName,
        field: item.caseField,
        name: item.caseName,
        editable: false,
        deletable: false,
        isFrozen: false,
      })),
    ];

    return columnsResults;
  }

  setResultsInTable(columns: TableColumn[], rows: TableRow[], isVisble: boolean){

    this.columnsResults.set(columns);
    this.rowsResults.set(rows);
    this.isResultVisible.set(isVisble);
  }

  // Main function to run the model
  runModel(){
    this.isSpinnerVissible.set(true);
    const requestData = this.mapTableModelPredictionsInputs(this.inputRows(), this.inputColumns());

    this.modelPredictionsService.runModel(requestData).subscribe({
      next: (data) => this.handleModelResponse(data, requestData),
      error: (err) => {
        this.isSpinnerVissible.set(false);
        this.handleErrorMessage(err?.message || 'Failed to run model', 'Please try again.');
      }
    });
  }

  // Handle the response from the model run
  private handleModelResponse(data: ModelResultResponse, requestData: ModelPredictionsInputs[]): void {
    this.isSpinnerVissible.set(false);

    if(data.errorMsg !== null){
      this.isResultVisible.set(false);
      this.handleErrorMessage(data.errorMsg, "Please check the inputs and try again.");
      return;
    }

    this.processAndDisplayResults(data, requestData);
  }

  // Process and display the results in the UI
  private processAndDisplayResults(data: ModelResultResponse, requestData: ModelPredictionsInputs[]): void {
    const updatedData = this.updateUiCaseNameInDataSet(data, requestData);
    const resultsColumns = this.mapPredictionsResultsColumns(updatedData);
    const resultsRows = this.mapPredictionsResultsRows(updatedData);

    this.setResultsInTable(resultsColumns, resultsRows, true);
    this.updateResultsServiceValues();
    this.savePredictions(updatedData);
  }

  // Save the predictions if the user has permission
  private savePredictions(updatedData: ModelResultModel[]): void {
    const saveModels = this.buildSavePredictionsModels(updatedData);
    const canGiveFeedback = this.permissionService.can('feedback:give');

    if(!saveModels.length || !canGiveFeedback) return;

    this.savingPredictions.set(true);
    this.modelPredictionsService.save(saveModels).subscribe({
      next: (res) => {
        if(res?.errorMsg){
          this.handleErrorMessage(res.errorMsg, 'Predictions calculated but not persisted.');
        }
      },
      error: (err) => console.error('Save predictions failed', err),
      complete: () => this.savingPredictions.set(false)
    });
  }

  private buildSavePredictionsModels(results: ModelResultModel[]): SavePredictionsModel[] {
    if(!results || results.length === 0) return [];
    const runDateIso = this.toApiRunDateString();
  const profile = this.userProfileStore.userProfile();
  const userId = profile.email || profile.id || '';
    return results.map(r => ({
      userId,
      runDate: runDateIso,
      caseName: r.caseName,
      predictedValue: r.caseAveragePrice,
      caseId: r.caseId
    }));
  }


  handleErrorMessage(errorMessage: string, secondErrorMessage: string = "") {
    let errorMsg = `An error occurred while running the model: ${errorMessage}`;
    this.errorMessage.set(errorMsg);
    this.secondErrorMessage.set(secondErrorMessage);
    this.isNotificationPopupOpen.set(true);
  }

  updateUiCaseNameInDataSet(data: ModelResultResponse, requestData: ModelPredictionsInputs[]) {

    const updatedDataSet: ModelResultModel[] = data.results.map(item => {

      const foundInput = requestData.find(input => input.scenarioField === item.caseName);

      if (foundInput) {
        item.caseField = foundInput.scenarioField;
        item.caseName = foundInput.scenarioName;
      }

      return item;

    })

    return updatedDataSet;

  }

  // resetValues(){

  //     this.isResetSpinnerVissible.set(true);

  //     let inputRows: TableRow[] = this.modelPredictionsService.getInputRowsBackup()();
  //     let inputColumns: TableColumn[] = this.modelPredictionsService.getInputColumnsBackup()();

  //     this.inputColumns.update(()=> inputColumns);
  //     this.inputRows.update(()=>inputRows);

  //     this.updateCurrentInputsValues();


  //     this.setResultsInTable([], [], false);
  //     this.updateResultsServiceValues();

  //     this.setDate();

  //     this.getDataFromService();

  //     this.isResetSpinnerVissible.set(false);
  // }

  resetValues() {
    if (this.isResetSpinnerVissible()) return;
    this.isResetSpinnerVissible.set(true);
    // Gray out save button and clear any pending state
    this.chevronDirty.set(false);
    this.isChevronConfirmOpen.set(false);
    this.preparingChevronConfirm.set(false);
    this.loadingBaseline.set(false);
    this.chevronAuditTrail.set({ changes: [] });
    this.chevronConfirmDetails.set({ diffs: [] });

    const inputRows: TableRow[] = this.modelPredictionsService.getInputRowsBackup()();
    const inputColumns: TableColumn[] = this.modelPredictionsService.getInputColumnsBackup()();

    this.inputColumns.update(() => inputColumns);
    this.inputRows.update(() => inputRows);

    this.updateCurrentInputsValues();
    this.setResultsInTable([], [], false);
    this.updateResultsServiceValues();
    this.setDate();

    // Reload fresh data; stop spinner when it completes via subscribe completion
    const done = () => this.isResetSpinnerVissible.set(false);
  this.modelPredictionsService.GetInputsAndValuesFromService({ ...this.navBarFilters, selectedDate: '' }).subscribe({
      next: (data: ModelInputResponse) => {
        if ((data.errorMsg && data.errorMsg.length > 0) || data.results.length === 0) {
          this.handleError(data.errorMsg || 'No inputs and values found for the selected project and date.');
          return;
        }
        this.backupDate = this.date ? this.date : new Date();
        this.SharedDataService.setIsNavbarEnabled(true);
        this.inputsVisible.set(true);
        this.isInputsModuleVisible.set(true);
        this.mapInputsFromService(data);
      },
      error: _ => {
        // error handled in handleError call; ensure spinner stops
        this.isResetSpinnerVissible.set(false);
      },
      complete: done
    });
  }


  onDateChange(event: any) {
  this.isDateSpinnerVissible.set(true);
    const selectedDate = new Date(event);
    this.setDateInBackupAndUi(selectedDate);
  this.chevronAuditTrail.set({ changes: [] });
  this.chevronConfirmDetails.set({ diffs: [] });
  this.isChevronConfirmOpen.set(false);
  this.preparingChevronConfirm.set(false);
  this.loadingBaseline.set(false);
  this.chevronDirty.set(false);
  this.getDataFromService(this.formatDate(selectedDate));
  }

  setDateInBackupAndUi(selectedDate: Date){
    let currentDate= this.formatDate(selectedDate);
    this.setDate(currentDate);
    this.setCurrentScope(selectedDate);
  }

  //new Date();

  openChartsWindow() {
    this.isChartsModalOpen.set(true);
  }

  closeChartsWindow() {
    this.isChartsModalOpen.set(false);
  }

  formatDate(dateInput: Date): string {

  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };

    let date = new Date(dateInput);

    if (isNaN(date.getTime())) {
    date = new Date();
    }
    return date.toLocaleDateString('en-US', options);

  }

  // Spinner logic for Run button: show when running, resetting, or changing date
  runButtonLoading(): boolean {
    return this.isSpinnerVissible() || this.isResetSpinnerVissible() || this.isDateSpinnerVissible();
  }



  getRowsCategories(rows: TableRow[]) {
    let rowsCategories: string[] = [];
    rows.forEach(row => {
      if (row.dataCategory !== undefined && row.dataCategory.length > 0) {
        rowsCategories.push(row.dataCategory.toLowerCase());
      }
    });
    rowsCategories = [...new Set(rowsCategories)];
    this.rowsCategories.update(()=>rowsCategories);

    return;
  }

}



